import { render, staticRenderFns } from "./PaymentDetailsModal.vue?vue&type=template&id=d6ff5a3a&"
import script from "./PaymentDetailsModal.vue?vue&type=script&lang=js&"
export * from "./PaymentDetailsModal.vue?vue&type=script&lang=js&"
import style0 from "./PaymentDetailsModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports